import { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import cookie from '@/helpers/cookie';
import { useSearchZustandStore } from '@/helpers/searchctx.js';
import { useDebounce } from '@/helpers/common';
import { getRootUrl } from '@/helpers/router.js';
import { lang } from '@/helpers/translate';
import Emitter from '@/helpers/emitter.js';

/*
  set all data, filter map params, build all data url, graphql var, initparams
  and up them all
  when graphql var up => space/map listener will run
*/
function SearchEvent() {
  const searchEvent = useSearchZustandStore((state) => state.searchEvent);
  const debounceSearchEvent = useDebounce(searchEvent, 500);
  const langCurrent = lang();
  const router = useRouter();

  useEffect(() => {
    const {
      initParams, filtersOutput, mapOutput, currentPage,
      urls, userUsingPlateform, filterEvent, initializedMap,
    } = useSearchZustandStore.getState();
    const newFilterUrls = [...urls];
    const newCurrentPage = currentPage || (initParams?.page || 1);
    // console.log('search/events/search ff', filtersOutput, filterEvent, userUsingPlateform);

    const varFromFilters = (filtersOutput || []).reduce((acc, f) => {
      const newAcc = { ...acc };
      if (newAcc[f.slug] && Array.isArray(f.graphql[f.slug])) {
        newAcc[f.slug] = newAcc[f.slug].concat(f.graphql[f.slug]);
        return { ...newAcc };
      }
      return { ...acc, ...(f.graphql || {}) };
    }, {});

    // values selected for graphql
    const newVariables = {
      front: true,
      ...varFromFilters,
      ...{
        boundaries: mapOutput.boundaries,
        zoom: mapOutput.zoom,
      },
      limit: {
        from: ((newCurrentPage || 1) - 1) * 24,
        to: 24,
      },
    };

    console.log('WEA169DEBUG search EVENT', debounceSearchEvent?.action, 'boundaries', JSON.stringify(newVariables?.boundaries));
    if (!initializedMap || !newVariables?.boundaries || filterEvent === 'notready') {
      // console.log('search/events/search - ERRROR , map not initialized, filter not ready');
      return;
    }

    let moreStoreData = {};
    if (userUsingPlateform) {
      // values for urls and initparams
      // creating phase each filters will pick values inside initparams belong to
      newFilterUrls.push({
        slug: 'hub',
        values: [initParams.hub],
      }, {
        slug: 'title',
        values: [initParams.title],
      }, {
        slug: 'lat',
        values: [mapOutput.lat],
      }, {
        slug: 'lng',
        values: [mapOutput.lng],
      }, {
        slug: 'page',
        values: [newCurrentPage],
      });
      newFilterUrls.push({
        slug: 'zoom',
        values: [newVariables.zoom || mapOutput.zoom],
      });

      const { newUrls, newInitParams } = newFilterUrls.reduce((acc, u) => {
        const newValues = [...new Set(u.values.join(',').split(','))];
        acc.newUrls.push(`${u.slug}=${newValues.join(',')}`);
        acc.newInitParams[u.slug] = newValues.join(',');
        return acc;
      }, { newUrls: [], newInitParams: {} });
      // console.log('search/events/search - urls');

      let seoQueries = Object.entries(router.query || {}).reduce((seoAcc, [seok, seov]) => {
        const newSeoAcc = [...seoAcc];
        if (['utm_source', 'utm_campaign', 'utm_term'].includes(seok)) {
          newSeoAcc.push(`${seok}=${seov}`);
        }
        return newSeoAcc;
      }, []);
      if (seoQueries.length) {
        seoQueries.unshift('');
        seoQueries = seoQueries.join('&');
      }
      const newRoute = `${getRootUrl(langCurrent)}/s/${initParams.hub}?${newUrls.join('&')}${seoQueries}`;

      const filteredDate = Object.entries(newInitParams || {}).filter(([slug]) => !['dates', 'lat', 'lng', 'zoom', 'page'].includes(slug));

      const newValue = Object.fromEntries(filteredDate);
      const urlSearch = JSON.stringify(newValue);
      cookie.set(`urlSearch${newInitParams?.hub}${newInitParams?.riders}`, urlSearch, {
        maxAge: 7 * 24 * 60 * 60,
      });

      window.history.pushState({ path: newRoute }, '', newRoute);
      router?.events?.emit('routeChangeComplete');
      moreStoreData = { initParams: { ...newInitParams } };
    }

    // console.log('search/events/search - emit varGraphql');
    // WEA-169 — boot avec grille SSR adoptée : varGraphql part quand même (la requête
    // markers de la carte en dépend) mais SANS le signal de chargement — la grille serveur
    // reste affichée telle quelle, events/space.js sautera ce premier fetch.
    // WEA-176 — la branche silencieuse couvre N'IMPORTE QUEL événement tant que le flag
    // d'adoption est actif, plus seulement mapinitDone : le debounce (500 ms) ne garde que
    // le DERNIER événement du boot, et selon la machine c'est l'init des FILTRES
    // (runSearchFromFilter) qui gagne — elle allumait alors le squelette par-dessus la
    // grille adoptée pour un fetch qui allait être sauté (double clipping visible).
    if (useSearchZustandStore.getState().skipNextSpacesFetch) {
      useSearchZustandStore.setState({ ...moreStoreData, varGraphql: newVariables });
      return;
    }
    Emitter.emit('spaceloadingsearch', true);
    useSearchZustandStore.setState({ ...moreStoreData, varGraphql: newVariables, ...(debounceSearchEvent?.action !== 'paginatorcallsearch' ? { currentPage: 1 } : {}) });
  }, [debounceSearchEvent]);

  return null;
}

export default SearchEvent;
